export function hexToRegex(hex: string): RegExp | null {
    hex = hex.replace(/^#/, '');
  
    if (hex.length === 6) {
      const r = (parseInt(hex.substring(0, 2), 16) / 255).toFixed(3);
      const g = (parseInt(hex.substring(2, 4), 16) / 255).toFixed(3);
      const b = (parseInt(hex.substring(4, 6), 16) / 255).toFixed(3);
  
      // Cria a regex com os valores normalizados
      const pattern = `"k":\\[\\s*${r}\\s*,\\s*${g}\\s*,\\s*${b}\\s*\\]`;
      return new RegExp(pattern, 'g');
    }
  
    return null;
  }

  export function hexToRgb(hex: string): string | null {
    // Remove o "#" caso exista
    hex = hex.replace(/^#/, '');
  
    // Verifica se a cor tem 6 caracteres (formato #RRGGBB)
    if (hex.length === 6) {
      // Converte os componentes hexadecimais para valores decimais RGB
      let r = (parseInt(hex.substring(0, 2), 16) / 255).toFixed(3);
      let g = (parseInt(hex.substring(2, 4), 16) / 255).toFixed(3);
      let b = (parseInt(hex.substring(4, 6), 16) / 255).toFixed(3);
      return [r, g, b].toString();
    }
    // Retorna null se o formato não for válido
    return null;
  }